'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dProduct18 from "./scala.-Product18.js";
var $p;
/** @constructor */
function $c_T18(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18) {
  this.o8 = null;
  this.oi = null;
  this.oj = null;
  this.ok = null;
  this.ol = null;
  this.om = null;
  this.on = null;
  this.oo = null;
  this.op = null;
  this.o9 = null;
  this.oa = null;
  this.ob = null;
  this.oc = null;
  this.od = null;
  this.oe = null;
  this.of = null;
  this.og = null;
  this.oh = null;
  this.o8 = _1;
  this.oi = _2;
  this.oj = _3;
  this.ok = _4;
  this.ol = _5;
  this.om = _6;
  this.on = _7;
  this.oo = _8;
  this.op = _9;
  this.o9 = _10;
  this.oa = _11;
  this.ob = _12;
  this.oc = _13;
  this.od = _14;
  this.oe = _15;
  this.of = _16;
  this.og = _17;
  this.oh = _18;
}
export { $c_T18 as $c_T18 };
$p = $c_T18.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_T18;
/** @constructor */
function $h_T18() {
}
export { $h_T18 as $h_T18 };
$h_T18.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.n = (function() {
  return 18;
});
$p.g = (function(n) {
  return $j_scala$002e$002dProduct18.$f_s_Product18__productElement__I__O(this, n);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, (-937041276), true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_T18) && ((((((((((((((((($j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.o8, x$0.o8) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oi, x$0.oi)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oj, x$0.oj)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.ok, x$0.ok)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.ol, x$0.ol)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.om, x$0.om)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.on, x$0.on)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oo, x$0.oo)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.op, x$0.op)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.o9, x$0.o9)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oa, x$0.oa)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.ob, x$0.ob)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oc, x$0.oc)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.od, x$0.od)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oe, x$0.oe)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.of, x$0.of)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.og, x$0.og)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oh, x$0.oh))));
});
$p.o = (function() {
  return "Tuple18";
});
$p.b = (function() {
  return (((((((((((((((((((((((((((((((((((("(" + this.o8) + ",") + this.oi) + ",") + this.oj) + ",") + this.ok) + ",") + this.ol) + ",") + this.om) + ",") + this.on) + ",") + this.oo) + ",") + this.op) + ",") + this.o9) + ",") + this.oa) + ",") + this.ob) + ",") + this.oc) + ",") + this.od) + ",") + this.oe) + ",") + this.of) + ",") + this.og) + ",") + this.oh) + ")");
});
function $isArrayOf_T18(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eH)));
}
export { $isArrayOf_T18 as $isArrayOf_T18 };
var $d_T18 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_T18, "scala.Tuple18", ({
  eH: 1,
  b: 1,
  c: 1,
  rQ: 1,
  a: 1
}));
export { $d_T18 as $d_T18 };
